export const iconFontAwesomeSportsFitnessFootball = (
	<i className="fa-solid fa-football"></i>
);
